import { gql } from 'urql';

export const IllustrationStyleDictionary = gql`
  fragment IllustrationStyleDictionary on IllustrationStyleDictionary {
    id
    fallbackURL
    illustrationKey
    __typename
  }
`;
